import { useState } from "react"
import { post } from "../../api/api"

export default function LinkDiscovery() {
  const [domain, setDomain] = useState("")
  const [links, setLinks] = useState(null)

  async function discover() {
    const res = await post("/link-discovery", { domain })
    setLinks(res.data)
  }

  return (
    <div className="page">
      <h1>Link Discovery</h1>
      <div className="card form-row">
        <label>
          URL or domain
          <input value={domain} onChange={(e) => setDomain(e.target.value)} placeholder="example.com" />
        </label>
        <button onClick={discover}>Discover links</button>
      </div>
      {links && (
        <div className="card">
          <p>Internal links: {links.internalLinks}</p>
          <p>External links: {links.externalLinks}</p>
          <p>Total links: {links.links}</p>
        </div>
      )}
    </div>
  )
}
